import { AlternativeRegistrationModalProvider } from '@exam-center/alternative-registration';
import { RegistrationDetailsLogic } from '@exam-center/proctoring-registrations';
import { Flex } from '@shared/components';

export default function ProctorRegistrationDetailsPage() {
  return (
    <AlternativeRegistrationModalProvider>
      <Flex sx={{ flexDirection: 'column', height: '100%', overflow: 'auto' }}>
        <Flex sx={{ flex: 1, p: (theme) => theme.spacing(6) }}>
          <RegistrationDetailsLogic />
        </Flex>
      </Flex>
    </AlternativeRegistrationModalProvider>
  );
}
